(function () {
  'use strict';

  var Utils = window.TDCUtils;

  function initSliders() {
    document.querySelectorAll('[data-slider]').forEach(function (sl) {
      if (sl.__sliderInitialized) return;
      sl.__sliderInitialized = true;

      var rail = sl.querySelector('.rail');
      var prev = sl.querySelector('[data-prev]');
      var next = sl.querySelector('[data-next]');
      var bar = sl.querySelector('[data-bar]');
      var count = sl.querySelector('[data-count]');
      if (!rail) return;

      var cards = rail.children;
      if (!cards.length) return;

      function step() {
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
        var first = cards[0];
        return first ? first.getBoundingClientRect().width + gap : 300;
      }

      function visible() {
        return Math.max(1, Math.round((rail.clientWidth + 1) / step()));
      }

      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        var first = Math.round(rail.scrollLeft / step());
        var shown = Math.min(cards.length, first + visible());
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max - 2;
        if (count) count.textContent = shown + ' / ' + cards.length;
        if (bar) {
          var w = Math.min(100, (visible() / cards.length) * 100);
          bar.style.width = w + '%';
          bar.style.transform = 'translateX(' + (max > 0 ? (rail.scrollLeft / max) * ((100 - w) / w) * 100 : 0) + '%)';
        }
      }

      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * visible(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() * visible(), behavior: 'smooth' }); });

      rail.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); if (next) next.click(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); if (prev) prev.click(); }
      });

      rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', Utils.debounce(update, 150));
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  window.TDCSlider = {
    init: initSliders
  };
})();